export default "__VITE_ASSET__poHBdDQE__"